import { Button, HStack } from '@chakra-ui/react';
import React, { FC } from 'react';
import { useRouter } from 'next/router';

import { Icon } from '@app/components/Icon';
import { Position } from '@app/types/pool';
import { APP_ROUTES } from '@app/constants/routes';

interface Props {
  data: Position;
}

export const PositionControls: FC<Props> = ({ data }) => {
  const router = useRouter();

  return (
    <>
      <HStack justify="space-around" width="100%" gap="20px">
        <Button
          variant="tertiary"
          width="100%"
          leftIcon={<Icon name="addLiquidity" />}
          onClick={() =>
            router.push(
              `${APP_ROUTES.addLiquidityPage}?token0=${data.pair.token0.id}&token1=${data.pair.token1.id}`
            )
          }
        >
          Add
        </Button>
        <Button
          variant="error"
          width="100%"
          leftIcon={<Icon name="removeLiquidity" />}
          onClick={() => {
            router.push(
              `${APP_ROUTES.removeLiquidityPage}?pairId=${data.pair.id}`
            );
          }}
        >
          Remove
        </Button>
      </HStack>
    </>
  );
};
